import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { EditableProps } from "@builder/components/editable/editableProps";
import TextInput from "@builder/components/general/TextInput";
import Toggle from "@builder/components/general/Toggle";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { setActiveNode, updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { SearchNode } from "@common/build/types";

const Search = ({ parent }: EditableProps) => {
    const dispatch = useAppDispatch();
    const sNode = useAppSelector(getSelectedNode) as SearchNode;
    const activeNode = useAppSelector(state => state.builder.activeNode);

    const placeholder = sNode.input?.placeholder || "";
    const placeholderCallback = (value: string) => {
        dispatch(updateNodeProperty({ propertyPath: ["input", "placeholder"], value }));
    };

    const activeCallback = (checked: boolean) => {
        dispatch(setActiveNode(checked ? sNode.id : null));
    };

    const included = sNode.included;
    const productsCallback = (checked: boolean) => {
        dispatch(updateNodeProperty({ propertyPath: ["included", "products"], value: checked }));
    };
    const customersCallback = (checked: boolean) => {
        dispatch(updateNodeProperty({ propertyPath: ["included", "customers"], value: checked }));
    };
    const ordersCallback = (checked: boolean) => {
        dispatch(updateNodeProperty({ propertyPath: ["included", "orders"], value: checked }));
    };

    return (
        <SidebarCollapse title="Search" parent={parent}>
            <TextInput title="Placholder text" value={placeholder} placeholder="Enter text" callback={placeholderCallback} />
            <Toggle label="Show active" checked={activeNode === sNode.id} callback={activeCallback} />
            <Toggle label="Include products in search" checked={included?.products || false} callback={productsCallback} />
            <Toggle label="Include customers in search" checked={included?.customers || false} callback={customersCallback} />
            <Toggle label="Include orders in search" checked={included?.orders || false} callback={ordersCallback} />
        </SidebarCollapse>
    );
};

export default Search;
